import React, { useState } from 'react'
import { StyleSheet, View, Text } from 'react-native'
import { useTheme } from '@react-navigation/native'
import { Theme } from '@theme'
import { BottomModalBase } from '../../../../components/molecules/BottomModal'
import { Button } from '../../../../components/molecules/Button'
import { PhotoCategory, TitleCategory } from '../../../../screens/menu/categories/AddCategory'
import { useCreateCategory } from '@hooks'
import { useLanguage } from '@context'

export const AddCategoryModal = ({
  isVisible,
  setIsVisible
}: {
  isVisible: boolean;
  setIsVisible: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const theme = useTheme()
  const { t } = useLanguage()
  const styles = getStyle(theme)
  const [photo, setPhoto] = useState<string | undefined>(undefined);
  const [title, setTitle] = useState<string>('');

  const { mutate: addCategory } = useCreateCategory();

  const handleAddPhoto = (uri: string) => {
    setPhoto(uri)
  };

  const handleSave = () => {
    addCategory({
      name: title,
      avatar: photo ? { uri: photo } : undefined,
      contactAccountIds: []
    })
    setTitle('')
    setPhoto(undefined)
    setIsVisible(false)
  }

  return (
    <BottomModalBase isVisible={isVisible} setIsVisible={setIsVisible} largePaddingTop={false} hasCloseButton>
      <View style={styles.container}>  
        <Text style={styles.title}>{t('addCategoryModal.title')}</Text>
        <PhotoCategory photo={photo} onAddPhoto={handleAddPhoto} />
        <TitleCategory title={title} setTitle={setTitle} />
        <Button
          title={t('addCategoryModal.save')}
          onPress={handleSave}
          unfilled={false}
        />
      </View>
    </BottomModalBase>
  )
}

const getStyle = (theme: Theme) =>
  StyleSheet.create({
    container: {
      width: '100%',
      paddingBottom: theme.spacing.xl,
      paddingHorizontal: theme.spacing.xl,
      paddingTop: theme.spacing.lg,
    },
    title: {
      color: theme.colors.text,
      fontSize: theme.fontSize.large,
      fontWeight: 'bold',
      paddingBottom: theme.spacing.xl,
    },
    sectionTitle: {
      fontSize: theme.fontSize.extraSmall,
      color: theme.colors.greyBlue,
      fontWeight: '400',
      paddingTop: theme.spacing.lg,
      paddingBottom: theme.spacing.xs,
    },
    categoriesList: {
    },
    categoryItem: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      backgroundColor: 'transparent',
      paddingVertical: theme.spacing.md,
      borderBottomWidth: 0.5,
      borderBottomColor: theme.colors.grey,
    },
    categoryContent: {
      flexDirection: 'row',
      alignItems: 'center',
      flex: 1,
    },
    categoryIcon: {
      width: 50,
      height: 50,
      borderRadius: 25,
      justifyContent: 'center',
      alignItems: 'center',
      marginRight: theme.spacing.lg,
    },
    categoryInfo: {
      flex: 1,
    },
    categoryName: {
      fontSize: theme.fontSize.large,
      fontWeight: '600',
      color: theme.colors.text,
      marginBottom: theme.spacing.xs,
    },
    categorySubtitle: {
      fontSize: theme.fontSize.medium,
      color: theme.colors.greyBlue,
      fontWeight: '400',
    },
  }) 